import { useProjectStore } from '../../store/projectStore';

export const readBoothVaultPublicOriginFromSelectedApplication = ():
  | string
  | null => {
  const url = useProjectStore.getState().selectedTarget?.url?.trim();
  return url ? url : null;
};
